/** Format user rating like Bolt: 4.8 (12) */
export function formatUserRating(avg: number | null | undefined, count: number | null | undefined): string | null {
  if (avg == null || !count || count <= 0) return null
  return `${avg.toFixed(1)} ★ (${count})`
}
